import React from 'react'

import Collapsible from 'react-collapsible';
import Border from '../Border'
import Product from '../Product'
import AddProduct from '../AddProduct';

import Section from './editable/Section'

import Backend from '../../utils/Backend'

import Titles from './editable/Titles';
import Navigation from "../../utils/Navigation";
import ProductCardColorSwatchSettings from '../ProductCardColorSwatchSettings';

import Block from "./Block";
import General from '../../utils/General';

const PRODUCTS_NO_OPTIONS = [
  {
    label: "3",
    value: 3
  },
  {
    label: "6",
    value: 6
  },
  {
    label: "9",
    value: 9
  }
]

export default class Block40 extends Block {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      editable: props.editable,
      products: [],
      categories: [],
    }

  }

  componentDidMount(){
    this._setup()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._setup())
  }

  _setup(){
    let {
      data,
      products
    } = this.state

    if(products.length === 0){
      this._loadProducts(data.extra?.products)
    }
  }

  _loadProducts(products){
    let {
      data
    } = this.state

    this.setState({ loading: true })

    Backend.getProducts(products).then(products => {
      products = products?.splice(0, data.extra?.products_no || 3)
      this.setState({ products, loading: false })
      return Backend.getProductCategories()
    }).then(categories => {
      this.setState({ categories })
    }).catch(error => {
      this.setState({ loading: false })
    })
  }

  _update(data, callback){
    this.setState({ ...data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  _getModalContent(data){
    let {
      products,
      categories
    } = this.state
    return (
      <>
        <Border>
          <Collapsible
            trigger="Product collection to be displayed"
          >
            <br/>
            <div className="input-select">
              <select
                value={data.extra?.product_category || null}
                onChange={e => {
                  let id = parseInt(e.target.value)
                  let category = categories.find(category => category.id === id)
                  if(!data.extra) {
                    data.extra = {product_category: id, products: category.products, products_no: null}
                  }else {
                    data.extra.product_category = id
                    data.extra.products = category.products
                  }
                  this.setState({
                    data,
                    loading: true
                  }, () => this._loadProducts(category.products))
                  this._update({
                    data
                  })
                }}
              >
                { data.product_category == null &&
                  <option value="null">Select a Product Collection</option>
                }
                {
                  categories.map((category) => {
                    return (
                      <option value={category.id}>{ category.title }</option>
                    )
                  })
                }
              </select>
            </div>
          </Collapsible>
        </Border>


        <Border>
          <Collapsible
            trigger="Number of products to be displayed"
          >
            <br/>
            <div className="input-select">
              <select
                value={data.extra?.products_no}
                onChange={e => {
                  if(!data.extra) {
                    data.extra = {product_category: null, products_no: parseInt(e.target.value)}
                  }else {
                    data.extra.products_no = parseInt(e.target.value)
                  }
                  this._update({
                    data,
                    loading: true
                  }, () => this._loadProducts(data.extra.products))
                }}
              >
                {
                  PRODUCTS_NO_OPTIONS.map(option => {
                    return (
                      <option value={option.value}>{ option.label }</option>
                    )
                  })
                }
              </select>
            </div>
          </Collapsible>
        </Border>

        <ProductCardColorSwatchSettings
          data={data}
          update={(obj) => {
            this._update(obj)
          }}
        />

      </>
    )
  }

  _renderProducts(products, data){
    let {
      loading
    } = this.state

    if(loading){
      return this._renderProductsLoading(data)
    }

    return products?.map(product => {
      return (
        <Product
          key={product.id}
          product={product}
          onAddToCartPressed={(product, variant, customMessage, quantity) => this.props.onAddToCartPressed(product, variant, customMessage, quantity)}
          data={data}
        />
      )
    })
  }

  _renderProductsLoading(data){
    return (
      <>
        <Product data={data} />
        <Product data={data} />
        <Product data={data} />
      </>
    )
  }

  _renderContent(){
    let {
      data,
      loading,
      editable,
      products
    } = this.state

    let shop_url = `${Navigation.getCollectionUrl(data.extra?.product_category || "")}`

    if(!loading && (products?.length === 0 || !products)){
      return <AddProduct/>
    }

    let viewAllClassName = " mt--2  ";
    if (window.IS_CARD_STYLE_WEBSITE) {
      viewAllClassName = " dc-mt-1 ";
    }

    return (
      <>
        <Titles
          data={ data }
          editable={ editable }
          onUpdated={data => this._update(data)}
          rowCssClasses={"dc-mb-1"}
          alignment={"text-left"}
          headingNumber={2}
          headingDefaultText={"Product Collection"}
        />

        <hr className='dc-d-none' />

        <div className="row mt-5 dc-row-v3">

          { this._renderProducts(products, data) }

        </div>

        <div
          className={ viewAllClassName +' text-center ' }
        >
          <a
            className="btn btn--primary type--uppercase"
            href={shop_url}
            onClick={() => {
              General.setLocationHref(shop_url)
            }}
          >
            <span className="btn__text">View More</span>
          </a>
        </div>
      </>
    )
  }

  render(){
    let { data, editable, products, loading } = this.state

    if(!loading && !editable && products.extra?.length === 0){
      return null
    }

    let blockClassName = " block-40 product-blocks  ";
    if (window.IS_CARD_STYLE_WEBSITE) {
      blockClassName += " deep-cardify";
    }

    return (

      <Section
        data={ data }
        index={ this.props.index }
        className={ blockClassName }
        editable={ editable }
        onUpdated={data => this._update({ data })}
        onDelete={() => this.props.onDelete()}
        primaryColor={false}
        secondaryColor={false}
        onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
        renderModalContent={() => this._getModalContent(data)}
        canMoveUp={ this.props.canMoveUp }
        canMoveDown={ this.props.canMoveDown }
        onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
        onMoveUpPressed={ () => this.props.onMoveUpPressed() }
        onMoveDownPressed={ () => this.props.onMoveDownPressed() }
        onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
        <div className="container">

          { this._renderContent() }

        </div>
      </Section>

    )
  }
}
